module.exports = __webpack_public_path__ + "img/img_05.6f201f60.png";